import React, { useState, useEffect } from "react";
import { NavLink, Navigate, Link } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import { Calendar, DollarSign, Users, CreditCard, TrendingUp, Loader2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { userService } from "../../_services";
import Affiliate_Url_summary from './Affiliate_Url_summary';
import Groupno_summary from './Groupno_summary';
import Payments_Summary from './Payments_Summary';
import Transactions_Type from "./Transactions_Type";
import OrderPage from "../Admin/Users/OrderPage";
import CardFront from "./CardFront";
import CardBack from "./CardBack";

const SummaryPage = () => {
    const [userData, setUserData] = useState([]);
    const [referralList, setReferralList] = useState([]);
    const [shortName, setShortName] = useState('');
    const [fullName, setFullName] = useState('');
    const [accountInfo, setAccountInfo] = useState('');
    const [apiKey, setApiKey] = useState('');
    const [isKeyValue, setIsKeyValue] = useState(false);
    const [transactionTypes, setTransactionTypes] = useState({});
    const [transactionOptions, setTransactionOptions] = useState({});
    const [commissionData, setCommissionData] = useState([]);
    const [selectedOption, setSelectedOption] = useState('this_week');
    const [isChanged, setIsChanged] = useState(false);
    const [dataLoader, setDataLoader] = useState(false);
    const [secret] = useState('gc7cpragRuhmE7DB1xzq5rmJFs696ZTJ');
    const [isUserExist, setIsUserExist] = useState(false);
    const [isOrderCard, setIsOrderCard] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [showPaymentPopup, setShowPaymentPopup] = useState(false);
    const [primaryGn, setPrimaryGn] = useState('');
    const [dateTime, setDateTime] = useState('');
    const [groupStatus, setGroupStatus] = useState('');
    const [totals, setTotals] = useState('');
    const [pqInvitation, setPqInvitation] = useState('');

    useEffect(() => {
        initializeData();
    }, []);

    const initializeData = async () => {
        try {
            const usermetaData = window.atob(localStorage.getItem('ajs_user_id'));
            const [userId, userName] = usermetaData.split(':');

            setTimeout(() => {
                getUserSummaryDetails(userId, userName);
            }, 100);

            getUserTransaction(userId, 'This week');
            getUserGroups(userId, userName);

            const userInfo = window.atob(localStorage.getItem('_file_info'));
            setAccountInfo(userInfo);

            try {
                // GoogleSheetEntry: Verify if this is needed on every page load
                // This may be redundant - consider removing if not required
                const apiData = await userService.GoogleSheetEntry(userId);
                if (apiData && apiData.length > 0) {
                    getGoogleSheetEntry(apiData[0].orderId, apiData[0].groupNumber, apiData[0].date);
                }
            } catch (err) {
                // Silently handle - this appears to be optional functionality
                console.error('Google sheet error:', err);
            }
        } catch (error) {
            logout();
        }
    };

    const getGoogleSheetEntry = async (orderId, gn, date) => {
        // Google Sheets integration logic would go here
        console.log('Google Sheet Entry:', { orderId, gn, date });
    };

    const getUserSummaryDetails = async (userId, userName) => {
        try {
            // Fixed: Using correct service method with 2 parameters only
            const apiData = await userService.GetUserSummaryDetail(userId, userName);
            if (apiData.length > 0) {
                setUserData(apiData);
                setIsUserExist(true);
                setPrimaryGn(apiData[0].primaryGN);
                setDateTime(apiData[0].datetime);
                setGroupStatus(apiData[0].groupStatus);
                setTotals(apiData[0].totals);
                setPqInvitation(apiData[0].pqinvitation);

                const userInfo = window.atob(localStorage.getItem('hacker_user_detail'));
                const [sName, fName] = userInfo.split(':');
                setShortName(sName);
                setFullName(fName);

                if (apiData[0].pqkey !== '' && apiData[0].pqkey !== null) {
                    setIsKeyValue(true);
                    setApiKey(apiData[0].pqkey);
                }
            }
        } catch (error) {
            console.error('Error fetching user summary:', error);
        }
    };

    const decryptData = () => {
        try {
            let decryptedData;
            let uctdData = localStorage.getItem('UCTD_Enc');
            if (uctdData !== null) {
                let databytes = CryptoJS.AES.decrypt(uctdData, secret);
                decryptedData = databytes.toString(CryptoJS.enc.Utf8);
            } else {
                decryptedData = null;
            }
            return decryptedData;
        } catch (err) {
            return null;
        }
    };

    const calculateTotals = (data) => {
        let totalDistComm = 0;
        let totalSubDistComm = 0;
        const currentYear = new Date().getFullYear();

        data.forEach(item => {
            const itemYear = parseInt(item.Date_Month.split(',')[1], 10);

            if (itemYear === currentYear) {
                totalDistComm += item.DistComm;
                totalSubDistComm += item.SubDistComm;
            }
        });

        return totalDistComm + totalSubDistComm;
    };

    const getUserTransaction = async (userId, dateFilter) => {
        setDataLoader(true);
        try {
            const apiData = await userService.GetUserTransaction(userId, dateFilter);
            if (apiData.length > 0) {
                let decryptedData = decryptData();
                let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                let uctdData = localStorage.getItem('UCTD_Enc');
                
                if (uctdData === null || decryptedData !== JSON.stringify(apiData[0])) {
                    const cipherTransaction = CryptoJS.AES.encrypt(JSON.stringify(apiData[0]), secret).toString();
                    localStorage.setItem('UCTD_Enc', cipherTransaction);
                    decryptedData = decryptData();
                }
                
                let comdata = JSON.parse(decryptedData).commissions;

                if (comdata !== '' && comdata !== null) {
                    comdata = JSON.parse(comdata);
                    const totalComm = calculateTotals(comdata);

                    setTotals(totalComm);
                    
                    comdata.sort((a, b) => {
                        if (a.Date_Month.split(',')[1] !== b.Date_Month.split(',')[1]) {
                            return b.Date_Month.split(',')[1] - a.Date_Month.split(',')[1];
                        } else {
                            return months.indexOf(b.Date_Month.split(',')[0]) - months.indexOf(a.Date_Month.split(',')[0]);
                        }
                    });
                    
                    setCommissionData(comdata);
                }
                
                if (!isChanged) {
                    setTransactionTypes(JSON.parse(JSON.parse(decryptedData).transactions).this_week[0]);
                } else {
                    setTransactionTypes(JSON.parse(JSON.parse(decryptedData).transactions)[selectedOption][0]);
                    setIsChanged(false);
                }
                
                setTransactionOptions(
                    JSON.parse(decryptedData).transactions !== '' ? 
                    JSON.parse(JSON.parse(decryptedData).transactions) : 
                    {}
                );
                
                setDataLoader(false);
            }
        } catch (err) {
            console.error('There is problem in fetching data. Please try again later.', err);
            setDataLoader(false);
        }
    };

    const getUserGroups = async (userId, userName) => {
        try {
            // Fixed: Using correct service method name and adding UserRole param
            const apiData = await userService.GetReferralList(userId, userName, 'Distributor');
            if (apiData.length > 0) {
                setReferralList(apiData);
            }
        } catch (error) {
            console.error('Error fetching user groups:', error);
        }
    };

    const handleTransactionFilterChange = (value) => {
        setSelectedOption(value);
        setIsChanged(true);
        const usermetaData = window.atob(localStorage.getItem('ajs_user_id'));
        const [userId] = usermetaData.split(':');
        getUserTransaction(userId, 'This week');
    };

    const togglePaymentPopup = () => {
        setShowPaymentPopup(!showPaymentPopup);
    };

    const logout = () => {
        localStorage.clear();
        window.location.href = '/signup';
    };

    // Check authorization
    if (window.atob(localStorage.getItem('UserRole')) !== "Distributor") {
        return <Navigate to="/page-not-found" replace />;
    }

    // Card data setup
    const mId = dateTime && dateTime !== '' ? dateTime.split('-').join('') : '';
    const cardsData = {
            bin: '023518',
            pcn: 'ARX',
        groupNumber: primaryGn || '',
        mId: mId
    };

    // Loading state
    if (userData.length === 0 || userData === null) {
        return (
            <div className="flex items-center justify-center h-96">
                <Loader2 className="h-12 w-12 animate-spin text-brand-accent" />
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {/* Transaction Type Cards Section */}
            <div className="space-y-4 mb-4">
                <div className="flex items-center justify-between">
                    <h2 className="text-3xl font-bold tracking-tight">
                        Transaction
                    </h2>
                    
                    <Select
                        value={selectedOption}
                        onValueChange={handleTransactionFilterChange}
                    >
                        <SelectTrigger className="w-[200px]">
                            <SelectValue placeholder="Select period" />
                        </SelectTrigger>
                        <SelectContent>
                            {Object.keys(transactionOptions).map((option, index) => (
                                <SelectItem key={index} value={option}>
                                    {option.split('_').join(' ').replace(/\b\w/g, l => l.toUpperCase())}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>

                <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                    {Object.keys(transactionTypes).map((transactionItem, index) => (
                        <Card key={index} className="hover:shadow-lg transition-shadow">
                            <CardContent className="pt-6">
                                <Transactions_Type 
                                    transactionItemName={transactionItem} 
                                    transactionItemCount={transactionTypes[transactionItem]} 
                                />
                            </CardContent>
                        </Card>
                    ))}
                    
                    {JSON.stringify(transactionTypes) !== '{}' && (
                        <Card className="hover:shadow-lg transition-shadow">
                            <CardContent className="pt-6">
                                {commissionData.length > 0 && commissionData !== '' ? (
                                    <Transactions_Type 
                                        transactionItemName={'Commission Earned'} 
                                        commissionData={commissionData} 
                                        secretK={secret} 
                                    />
                                ) : (
                                    <Transactions_Type 
                                        transactionItemName={'Commission Earned'} 
                                        commissionData={0} 
                                        secretK={secret} 
                                    />
                                )}
                            </CardContent>
                        </Card>
                    )}
                </div>
            </div>

                        {/* Summary Section */}
                        <div>
                            <h2 className="text-2xl font-bold text-slate-900 dark:text-slate-100 mb-4">
                                Summary
                            </h2>
                            
                            <div className="grid gap-6 lg:grid-cols-3">
                                {/* Left Column - 2/3 width */}
                                <div className="lg:col-span-2 space-y-4">
                                    {/* Affiliate URL Summary */}
                                    <Affiliate_Url_summary 
                                        customurlno={userData[0].customURL} 
                                        signedupno={userData[0].signedUp} 
                                    />
                                    
                                    {/* Payments Summary */}
                                    {isKeyValue ? (
                                        <Payments_Summary 
                                            pqKey={apiKey} 
                                            threshold={totals} 
                                            pqInviationstatus={pqInvitation} 
                                        />
                                    ) : (
                                        <Payments_Summary 
                                            pqKey={apiKey} 
                                            threshold={totals} 
                                            pqInviationstatus={pqInvitation}
                                        />
                                    )}
                                    
                                    {/* Personal Card Section */}
                                    <Card>
                                        <CardHeader className="flex flex-row items-center justify-between">
                                            <div className="flex items-center gap-2">
                                                <CreditCard className="h-5 w-5 text-primary" />
                                                <CardTitle>Your Personal Card</CardTitle>
                                        </div>
                                            {groupStatus && groupStatus === 'Yes' && (
                                                <Button variant="outline" size="sm" asChild>
                                                    <NavLink to="/cards">
                                                        Alternate Cards
                                                    </NavLink>
                                                </Button>
                                            )}
                                        </CardHeader>
                                        <CardContent>
                                            <div className="grid gap-4 md:grid-cols-2">
                                                <NavLink to="/cards" className="block">
                                                    <CardFront 
                                                        PrimaryGn={primaryGn} 
                                                        pcn={'ARX'} 
                                                        bin={'023518'} 
                                                        mId={mId} 
                                                        cardData={cardsData} 
                                                    />
                                                </NavLink>
                                                <CardBack 
                                                    PrimaryGn={primaryGn} 
                                                    isLinked={true} 
                                                    groupNumber={primaryGn} 
                                                    cardData={cardsData} 
                                                    mId={cardsData.mId} 
                                                />
                                    </div>
                                        </CardContent>
                                    </Card>
                                            </div>

                                {/* Right Column - 1/3 width */}
                                <div className="space-y-4">
                                    <Groupno_summary groupnumber={userData[0].groupNumber} />
                                    </div>
                                </div>
                            </div>

                        {/* Footer */}
                        <div className="pt-6 text-center">
                            <Link 
                                to="/compliance"
                                className="text-sm text-primary hover:underline inline-flex items-center gap-2"
                            >
                                Terms, Conditions, & Compliance Resources
                            </Link>
                        </div>

                        {/* Payment Popup Modal */}
                        {showPaymentPopup && (
                            <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
                                <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                                    <OrderPage toggle_user_detail={togglePaymentPopup} />
                                </div>
                            </div>
                        )}
        </div>
        );
};

export default SummaryPage;
